'use client'

import React from 'react'
import Image from 'next/image'

const platforms = [
    {
        name: 'Reddit',
        logo: '/logos/reddit-logo.png',
        bg: 'bg-[rgba(255,68,0,0.2)]',
        boxBg: 'bg-[#ff4400]',
        textColor: 'text-[#ff4400]',
        size: { w: 35, h: 35 },
    },
    {
        name: 'X',
        logo: '/logos/x-logo.png',
        bg: 'bg-black/5',
        boxBg: 'bg-black',
        textColor: 'text-black/80',
        size: { w: 35, h: 35 },
    },
    {
        name: 'Youtube',
        logo: '/logos/youtube-logo.png',
        bg: 'bg-[rgba(255,0,0,0.2)]',
        boxBg: 'bg-white',
        textColor: 'text-red-600',
        size: { w: 50, h: 35 },
    },
    {
        name: 'Threads',
        logo: '/logos/threads-logo.png',
        bg: 'bg-black/5',
        boxBg: 'bg-black',
        textColor: 'text-black/80',
        size: { w: 85, h: 82 },
    },
]

export function ConnectSection() {
    return (
        <section className="w-full px-5 md:px-0 md:py-20 flex items-center justify-center">
            <div className="bg-[rgba(0,0,0,0.02)] border border-[rgba(0,0,0,0.02)] rounded-[32px] w-full max-w-[864px] mx-auto flex flex-col items-center gap-10 p-5 md:p-20">
                <p
                    className="font-bold text-[26px] leading-8 text-center text-black/80 w-full max-w-[403px] mx-auto mb-2"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                >
                    Stay up to date
                </p>

                {/* Responsive grid */}
                <div
                    className="w-full grid gap-5 justify-center items-start
                               grid-cols-[repeat(auto-fit,minmax(140px,140px))]"
                >
                    {platforms.map((p) => (
                        <div
                            key={p.name}
                            className={`${p.bg} cursor-pointer border border-[rgba(0,0,0,0.02)] rounded-2xl w-full h-[162px] flex flex-col items-center p-2.5 gap-2.5`}
                        >
                            <div
                                className={`${p.boxBg} rounded-xl w-full aspect-square flex items-center justify-center shadow-md relative`}
                            >
                                <Image
                                    src={p.logo}
                                    alt={`${p.name} Logo`}
                                    width={p.size.w}
                                    height={p.size.h}
                                    className="object-contain"
                                />
                            </div>

                            <p
                                className={`${p.textColor} text-[10px] leading-3 font-normal`}
                                style={{ fontFamily: 'Inter, sans-serif' }}
                            >
                                {p.name}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
